import { useMemo } from 'react';
import { useSelector } from 'react-redux';

/**
 * Normalized retailer WhatsApp line (E.164) for call UI.
 *
 * @returns {string}
 */
export default function useWhatsappCallDefaultFrom() {
  const phoneNumber = useSelector(
    (state) => state.retailerUsersReducer.retailer_info?.phone_number
  );

  return useMemo(() => {
    if (!phoneNumber) return '';
    const trimmed = phoneNumber.trim().replace(/^\++/, '');
    return `+${trimmed}`;
  }, [phoneNumber]);
}
